import React, { useEffect } from "react";
import { StudyWorkspace } from "./Workspace";
import { useNotebookContext } from "../hooks/useNotebook";
import { Notebook } from "../client";
import { CanvasCourse } from "@/lib/types";
import { FileWorkspace } from "./FileWorkspace";
import { StudyNotUploadedDocument } from "../types";

interface FileSidebarProps {
  course: CanvasCourse;
  file: StudyNotUploadedDocument;
  returnUrl: string;
}
export default function FileSidebar({
  course,
  file,
  returnUrl,
}: FileSidebarProps) {
  // const [landingOpen, setLandingOpen] = React.useState(true);
  const { addSelectedSource } = useNotebookContext();
  useEffect(() => {
    addSelectedSource({
      id: -1,
      notebook_id: 0,
      document_id: 0,
      name: "File",
      source: "course",
    });
  }, []);
  return <FileWorkspace course={course} file={file} returnUrl={returnUrl} />;
}
